<template>
  <label class="Trio-checkbox">
    <div>
      <input
        type="checkbox"
        id="policyAgreement"
        name="policyAgreement"
        v-model="agreement"
      />
    </div>
    <span
      >He leído y acepto los
      <a
        class="Trio-legal-link"
        href="https://trioteca.com/legal/aviso-legal-y-condiciones-generales"
        target="_blank"
        >Términos y condiciones</a
      >
      y la
      <a
        class="Trio-legal-link"
        href="https://trioteca.com/legal/politica-de-privacidad"
        target="_blank"
      >
        Política de privacidad de TRIOTECA</a
      >.</span
    >
  </label>
</template>

<script>
import { Store } from "../store/index";

export default {
  name: "checkBoxForm",
  props: ["value"],
  computed: {
    agreement: {
      get() {
        return Store.getters["personalData/agreement"];
      },
      set(agreement) {
        Store.commit("personalData/SET_AGREEMENT", agreement);
      },
    },
  },
};
</script>

